import { WeekdayWeekendProvider } from '../providers/weekdayWeekendProvider';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_WEEKDAY_WEEKEND_BY_LATLON = new AsyncAction('GET_WEEKDAY_WEEKEND_BY_LATLON');

export function getWeekdayWeekendForecast(...params) {
  
    let paramsObject = {
        latitude: undefined,
        longitude: undefined,
        temperatureUnit: undefined,
        speedUnit: undefined,
        cultureInfo: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined
    };
    
    paramsObject = mapParamsToObject(params, paramsObject); 
    
    return {
        type: GET_WEEKDAY_WEEKEND_BY_LATLON.base,
        payload: getWeekdayWeekendForecastAsync(paramsObject)
    };
}
async function getWeekdayWeekendForecastAsync({latitude, longitude, temperatureUnit, speedUnit, cultureInfo, baseUrl, authId, secret, stdParameters, verbose, refresh}) {
    const op = new WeekdayWeekendProvider(baseUrl, authId, secret);
    const results = await op.getWeekdayWeekendForecast(latitude, longitude, stdParameters, temperatureUnit, speedUnit, cultureInfo, verbose, refresh);
    return results;
}